import { LegendList as BaseLegendList } from '@legendapp/list/react-native';
export default BaseLegendList;

export * from '@legendapp/list/react-native';
